module.exports = __webpack_public_path__ + "static/media/opsd.b21af505.png";